import React, { useEffect, useState } from 'react';
import { getGallery } from '../../services/marketingGalleryService';

const MarketingGallery = () => {
  const [photos, setPhotos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [lightboxIndex, setLightboxIndex] = useState(null); // null = closed

  useEffect(() => {
    const load = async () => {
      try {
        const data = await getGallery();
        setPhotos(data.photos);
      } catch (err) {
        // non-critical -- registration still works fine without the gallery
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  if (loading || photos.length === 0) return null;

  const showPrev = (e) => {
    e.stopPropagation();
    setLightboxIndex((i) => (i - 1 + photos.length) % photos.length);
  };
  const showNext = (e) => {
    e.stopPropagation();
    setLightboxIndex((i) => (i + 1) % photos.length);
  };

  return (
    <div style={styles.container}>
      <p style={styles.heading}>📸 View GrubClub Screenshots</p>
      <div style={styles.thumbRow}>
        {photos.map((photo, i) => (
          <img
            key={photo.id}
            src={photo.photo_url}
            alt={photo.caption || 'GrubClub screenshot'}
            style={styles.thumb}
            onClick={() => setLightboxIndex(i)}
          />
        ))}
      </div>

      {lightboxIndex !== null && (
        <div style={styles.overlay} onClick={() => setLightboxIndex(null)}>
          <button style={styles.closeBtn} onClick={() => setLightboxIndex(null)}>✕</button>
          {photos.length > 1 && (
            <button style={{ ...styles.navBtn, left: '20px' }} onClick={showPrev}>‹</button>
          )}
          <img
            src={photos[lightboxIndex].photo_url}
            alt={photos[lightboxIndex].caption || 'GrubClub screenshot'}
            style={styles.lightboxImg}
            onClick={(e) => e.stopPropagation()}
          />
          {photos.length > 1 && (
            <button style={{ ...styles.navBtn, right: '20px' }} onClick={showNext}>›</button>
          )}
          {photos[lightboxIndex].caption && (
            <p style={styles.caption}>{photos[lightboxIndex].caption}</p>
          )}
        </div>
      )}
    </div>
  );
};

const styles = {
  container: { marginBottom: '20px', textAlign: 'center' },
  heading: { color: '#e67e22', fontWeight: '600', fontSize: '14px', marginBottom: '10px' },
  thumbRow: { display: 'flex', gap: '8px', justifyContent: 'center', flexWrap: 'wrap' },
  thumb: {
    width: '70px', height: '70px', objectFit: 'cover', borderRadius: '8px',
    cursor: 'pointer', border: '1px solid #eee', boxShadow: '0 2px 6px rgba(0,0,0,0.08)',
  },
  overlay: {
    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.85)', display: 'flex', flexDirection: 'column',
    alignItems: 'center', justifyContent: 'center', zIndex: 2000, padding: '20px',
  },
  closeBtn: {
    position: 'absolute', top: '20px', right: '20px', background: 'none', border: 'none',
    color: 'white', fontSize: '28px', cursor: 'pointer',
  },
  navBtn: {
    position: 'absolute', top: '50%', transform: 'translateY(-50%)', background: 'rgba(255,255,255,0.15)',
    border: 'none', color: 'white', fontSize: '36px', cursor: 'pointer', borderRadius: '50%',
    width: '48px', height: '48px', lineHeight: '48px',
  },
  lightboxImg: { maxWidth: '90vw', maxHeight: '80vh', borderRadius: '8px' },
  caption: { color: '#ddd', fontSize: '13px', marginTop: '14px' },
};

export default MarketingGallery;
